import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { ChevronRight, Link, Check } from 'lucide-react';

const URLInputScreen = () => {
  const { setCurrentScreen, updateScanData } = useApp();
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (!url.trim()) {
      setError('Please enter a valid URL');
      return;
    }
    
    // Save URL to shared context
    updateScanData({
      url: { active: true, data: url }
    });
    
    setCurrentScreen('scan');
  };

  return (
    <div className="min-h-screen bg-black pb-24 flex flex-col">
      {/* Header */}
      <div className="px-6 pt-6 pb-4 flex items-center gap-4">
        <button
          onClick={() => setCurrentScreen('scan')}
          className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center hover:bg-white/20 transition-all flex-shrink-0"
        >
          <ChevronRight size={18} className="text-white rotate-180" />
        </button>
        <img src="/logos/logo-black.jpg" alt="ATELIA" className="h-16 w-auto object-contain" style={{ filter: 'invert(1)' }} />
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6">
        <div className="w-20 h-20 bg-white/10 rounded-3xl flex items-center justify-center mb-8">
          <Link size={36} className="text-white" strokeWidth={1.5} />
        </div>

        <h1 className="text-3xl font-bold text-white text-center mb-4 uppercase tracking-wide">
          Paste Product URL
        </h1>

        <p className="text-white/70 text-center text-sm max-w-xs mb-8 leading-relaxed">
          Enter the product link from any supported retailer website.
        </p>

        {/* URL Input */}
        <div className="w-full max-w-sm mb-8">
          <input
            type="url"
            value={url}
            onChange={(e) => { setUrl(e.target.value); setError(''); }}
            placeholder="https://www.net-a-porter.com/..."
            className="w-full px-4 py-4 bg-white/10 border border-white/20 rounded-xl text-white
              placeholder:text-white/40 focus:outline-none focus:border-white/40 transition-all"
          />
          {error && <p className="text-red-400 text-xs mt-2">{error}</p>}
        </div>

        <button
          onClick={handleSubmit}
          disabled={!url.trim()}
          className="w-full max-w-sm bg-white text-black py-4 px-8 rounded-2xl
            font-bold uppercase tracking-wide hover:bg-white/90 transition-all
            disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          <Check size={20} />
          Add URL
        </button>
      </div>

      {/* Supported Retailers */}
      <div className="px-6 pb-8">
        <div className="bg-white/5 rounded-xl p-4 border border-white/10">
          <p className="text-white/80 font-semibold text-xs uppercase mb-2">Supported Retailers</p>
          <p className="text-white/60 text-xs leading-relaxed">
            Myntra, Amazon, ASOS, Nordstrom, Selfridges, Ounass, and 30+ more luxury & premium retailers.
          </p>
        </div>
      </div>
    </div>
  );
};

export default URLInputScreen;